import type { EditorState } from "../../vendor/src/features/remotion-editor/editor/state/types";
import { getArrowKeyMoveIntent } from "../../vendor/src/features/remotion-editor/editor/keyboard-shortcuts/arrow-key-move-intent";
import { editableTree, itemOwner } from "./group-split";

/** The player and clip controls agree on ownership before either consumes an arrow key. */
export function getSelectionArrowAction(
  state: EditorState,
  key: string,
  altKey: boolean,
) {
  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(key))
    return null;
  const intent = getArrowKeyMoveIntent({
    activeSelectionSurface: state.activeSelectionSurface ?? null,
    key,
    altKey,
  });
  if (!intent) return null;
  const ids = [...new Set(state.selectedItems)].filter((id) => {
    const own = itemOwner(state, id);
    return own && !own.track.locked && editableTree(state, id);
  });
  return ids.length ? { intent, ids } : null;
}
